import ObjectModelBuilderModel from "../tracked/objectModelBuilderModel";
import ObjectModelAction from "./objectModelAction";
import Vue from "vue";

export default class ActionConfirmation extends ObjectModelBuilderModel {
  header: string = '';
  body: string = '';
  has_user_edited: boolean = false;

  constructor(action: ObjectModelAction, json: any = {}) {
    super();

    this.defineProperty('header', json['header'] || '');
    this.defineProperty('body', json['body'] || '');
    this.defineProperty('has_user_edited', json['has_user_edited']);

    this.rootModel = action.rootModel;
    this.parent = action;
    Vue.set(action, 'action_confirmation', this);
  }
}